import { z } from "zod";

/**
 * ItemFolhaPagamentoSchema
 */

export const ItemFolhaPagamentoSchema = z.object({
  idCentroCusto: z.coerce.number({ required_error: 'É necessário preencher este campo!', invalid_type_error: 'É necessário preencher este campo!' }),
  idFuncionarios: z.array(z.number(), { required_error: 'É necessário preencher este campo!', invalid_type_error: 'É necessário preencher este campo!' }),
  idResponsavel: z.coerce.number({ required_error: 'É necessário preencher este campo!', invalid_type_error: 'É necessário preencher este campo!' }),
  dataPagamento: z.coerce.date({ required_error: 'É necessário preencher este campo!', invalid_type_error: 'É necessário preencher este campo!' }),
  idSubconta: z.coerce.number().nullable().default(null),
});

/**
 * ItemFolhaPagamentoForm
 */

export type ItemFolhaPagamentoForm = z.infer<typeof ItemFolhaPagamentoSchema>;